import type { RouteLocationNormalizedGeneric } from 'vue-router';
import type { SectionId } from '~/types/sectionId';

export const useAccountBasePath = (to?: RouteLocationNormalizedGeneric) => {
    const route = to ?? useRoute();
    const { urlSegment, lang } = useLanguage();
    const sectionConfig = useCurrentSectionConfig(route);
    const countryLanguages = useCountryLanguages();

    const accountBasePath = computed(() => {
        const sectionPath = sectionConfig.value
            ? resolveSectionPath(sectionConfig.value, lang.value, countryLanguages)
            : null;
        return getAccountBasePath(urlSegment.value, sectionConfig.value?.sectionId, sectionPath);
    });

    return { accountBasePath };
};

export function getAccountBasePath(
    localeSegment: string | null | undefined,
    sectionId: SectionId | null | undefined,
    sectionPath: string | null | undefined
) {
    if (!localeSegment) {
        return '/account';
    }

    if (sectionId && sectionId !== 'root' && sectionPath) {
        return `/${localeSegment}/${sectionPath.replace(/^\/+|\/+$/g, '')}/account`;
    }

    return `/${localeSegment}/account`;
}
